export default customElements.define('w-section', class Section extends wealthify.CustomElementBaseClass {

    constructor () {
        const config = {
            styleSelector: 'c-section',
            templateHTML: '<div data-root></div>',
            hasChildren: true
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);
        };
    }
    static get validTypes () {
        return [
            'light', 'dark', 'gradient-1', 'gradient-3', 'primary', 'white', 'slate-grey-dark', 'jisa', 'aviva', 'danger', 'primary-tint'

        ];
    }

    static get observedProps () {
        return [
            new wealthify.Prop('variant', {
                default: 'white',
                type: wealthify.propTypes.ArrayItem([...this.validTypes])
            })
        ];
    }

    get propCallbacks () {
        return {variant: (value) => {
            [...this.constructor.validTypes].forEach((variant) => {
                this.classList.remove(`${this.styleSelector}--variant-${variant}`);
            });

            this.classList.add(`${this.styleSelector}--variant-${value}`);
        }};
    }

});